import * as Sentry from '@sentry/react';

const reported = new WeakSet();

/** Find ownership only on this error's chain, never inherited/global context. */
function reportingOwner(error, depth = 0) {
    if (!error || typeof error !== 'object' || depth > 5) return null;
    if (typeof error.sentryEventId === 'string' && /^[a-f0-9]{32}$/.test(error.sentryEventId))
        return error.sentryEventId;
    if (reported.has(error)) return 'client';
    return reportingOwner(error.originalError, depth + 1) || reportingOwner(error.error, depth + 1);
}

/** Capture unexpected failures once; server-owned failures remain breadcrumbs. */
export function captureBillingException(error, hint) {
    const owner =
        reportingOwner(error) ||
        reportingOwner(hint?.contexts?.full_error) ||
        reportingOwner(hint?.contexts?.api_response);
    if (owner) {
        Sentry.addBreadcrumb({
            category: 'billing.error',
            message: 'Previously reported failure received',
            level: 'error',
            data: { sentry_event_id: owner },
        });
        return;
    }
    if (error && typeof error === 'object') reported.add(error);
    return hint === undefined
        ? Sentry.captureException(error)
        : Sentry.captureException(error, hint);
}
